<app-assignments [portalUsers]="portalUsers" [usersAssigned]="usersAssigned" (assignmentChange)="assignmentsChanged($event)"></app-assignments>
